export default __webpack_public_path__ + "static/social-anomalias_en-120ea1bbb499c6210a26686674ef3a83.png";